export default {
  tfCustomValidation: (objToValidate, rowIndex, keys, customErrorMessage, param) => {

    const field = Object.keys(objToValidate)[0]
    const newValue = objToValidate[field]

    keys.split('|').every(key => {
      key = key.trim()
      var e = __getCustomErrors(rowIndex, field, key)
      if (e) {
        __removeCustomErrors(e)
      }

      if(!newValue && key !== 'required') return true;

      var validation = customValidation[key]
      var result = validation.validate(newValue, field, param)

      if (!result) {
        customErrors.push({
          row: rowIndex,
          field: field,
          key: key,
          msg: customErrorMessage || (typeof customValidation[key].message === 'function' ? customValidation[key].message(field) : customValidation[key].message),
        })
        return false // stop on first error
      }
      return true // continue to next property
    })
    return newValue
  },
  showCustomErrors: (rowIndex, field, key) => {
    var e = __getCustomErrors(rowIndex, field, key)
    return e ? e.msg : null
  },
  fieldValidation: (name, object) => {
    return object[name] ? 'valid': 'invalid'
  },
  customValidateAll: () => {
    return customErrors.length === 0
  }
}

export const customErrors = []
const customValidation = {
  required: {
    message: f => `${f} is required`,
    validate: (input) => {
      return (input || '').toString().length > 0
    }
  },
  phone: {
    message: 'Invalid Phone Format',
    validate: (input) => {
      return /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/.test(input)
    },
  },
  email: {
    message: 'Invalid Email Format',
    validate: (input) => {
      return  /^([\w.-]+)@([\w-]+)((\.(\w){2,4})+)$/.test(input)
    },
  },
  date_format: {
    message: 'Invalid Format',
    validate: (input) => {
      return /^(0[1-9]|1[0-2])\/([0-9]{2})$/.test(input)
    },
  },
  date_format_long: {
    // regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/([0-9]{4})$/,
    message: 'Invalid Format/Date',
    validate: (input) => {
      if (
        /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/([0-9]{4})$/.test(
          input
        )
      ) {
        var d1 = new Date(
          input.substr(6, 4),
          input.substr(0, 2) - 1,
          input.substr(3, 2)
        )
        if (
          input ===
          `${this.getDoubleDigit(
            d1.getMonth() + 1
          )}/${this.getDoubleDigit(d1.getDate())}/${d1.getFullYear()}`
        )
          return true
      }
      return false
    },
  },
  zip: {
    message: 'Zip is Invalid',
    validate: (input) => {
      return /^[0-9]{5}(?:-[0-9]{4})?$/.test(input)
    },
  },
  ssn: {
    message: 'SSN is Invalid',
    validate: (input) => {
      return /^\d{3}-?\d{2}-?\d{4}$/.test(input)
    },
  },
  dlno: {
    message: `The Driver's License Number field must be at least 4 characters`,
    validate: (input) => {
      return /^[0-9a-zA-Z]{4,}$/.test(input)
    },
  },
  name: {
    message: f => `${f} is Invalid`,
    validate: (input) => {
      return /^[A-Za-z0-9.' -]+$/.test(input)
    },
  },
  city: {
    message: 'City Name is Invalid',
    validate: (input) => {
      return /^[A-Za-z.' -]+$/.test(input)
    },
  },
  creditFile: {
    message: f => `${f} is Invalid`,
    validate: (input) => {
      return /^[A-Za-z0-9-]+$/.test(input)
    },
  },
  street: {
    message: 'Street is Invalid',
    validate: (input) => {
      return /^[A-Za-z0-9.'#@%&/ -]+$/.test(input)
    },
  },
  company: {
    message: f => `${f} is Invalid`,
    validate: (input) => {
      return /^[A-Za-z0-9.'_#@%&/ -]+$/.test(input)
    },
  },
  specialName: {
    message: f => `${f} is Invalid`,
    validate: (input) => {
      return /^[A-Za-z0-9.'#@%/ -]+$/.test(input)
    },
  },
}

function __removeCustomErrors(element) {
  var index = customErrors.indexOf(element)
  customErrors.splice(index, 1)
}
function __getCustomErrors(rowIndex, field, key) {
  return customErrors.find(
    // (x) => x.row === rowIndex && x.field === field && x.key === key
    (x) => x.row === rowIndex && x.field === field
  )
}
